<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title Códigos QR &nbsp
              i.fas.fa-qrcode
        .columns
          .column.is-offset-3.is-6
            Card(:device="device")
        .columns.has-text-centered
          .column
            router-link.a.button.is-black.is-rounded(:to="`/Codigos/Registro/${$route.params.id}`")
              | Registrar
</template>

<script>
  import NavBar from './layout/NavBar.vue'
  import Loader from '@/components/shared/Loader.vue'
  import Card from './components/Card'

  export default {
    name: 'CodigosQRComponentes',
    components: { NavBar, Loader, Card},
    data() {
      return {
        isLoading: true,
        device: {}
      }
    },
    methods: {
      async iniciarComponente() {
        const device = this.$route.params.id
        try {
          const data = await fetch(`https://10.121.40.125/servidores/inventario/equipos/status.php?e=${device}`)
          const response = await data.json()
          this.device = response[0]
          this.isLoading = false
        } catch (error) {
          this.displayToast(error.message, 'ban', 'OK')
          this.isLoading = false
        }
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    mounted () {
      setTimeout(() => {
        this.iniciarComponente()
      }, 1000)
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/codigosQR_Componentes/Home.vue